<template>
    <div class="pageContainer Menu" style="position: relative;">
       
        <el-row type="flex" style="margin-bottom: 20px" justify="start">
            <el-tabs v-model="activeName" type="border-card" style="width: 100%">
                
				
				<el-tab-pane  label="专业管理" name="zhuanye">
					<zhuanye v-if="activeName=='zhuanye'"></zhuanye>
				</el-tab-pane>
				
				
				 
            </el-tabs>
			
			
			
			
			
			
        </el-row>
		
		<!-- <div style="position: absolute; top: 15px; right: 30px; z-index: 999;">
			<el-button  size="mini" type="warning" @click="cloneMajor">初始化系部专业</el-button>
		</div> -->
		
		
        
    
    </div>
</template>
<script>
	import xibu from "./components/xibu.vue"
	import zhuanye from "./components/zhuanye.vue"
	import banji from "./components/banji.vue"
	
	export default {
		components:{
			xibu,
			zhuanye,
			banji
		},
		data () {
			return {
				activeName:"zhuanye"
			}
		},
		
		mounted() {
			
		},
		methods: {
			cloneMajor(){
				this.$http.post("/api/sch_major_clone").then(res=>{
					if(res.data.msg=="confirm"){
						this.$confirm(localStorage.getItem("year")+'年的系部专业已存在，是否重新初始化?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$http.post("/api/sch_major_clone", {
								force:1
							}).then(res => {
								this.$message({
									type: 'success',
									message: '初始化成功'
								});
						
								setTimeout(()=>{
									window.location.reload()
								},3000)
							})
						
						}).catch(() => {
						
						});
					}else if(res.data.msg=="success"){
						this.$message({
							type: 'success',
							message: '初始化成功'
						});
						setTimeout(()=>{
							window.location.reload()
						},3000)
					}
				})
			}
		}
	}
</script>
